import Http from '@/api/http.js'

export default {
  show() {
    return Http.get('/payment_reminder_config')
  },
  update(config) {
    return Http.put('/payment_reminder_config', {
      payment_reminder_config: {
        strategies: config.strategies,
      },
    })
  },
}

